<template>
  <div>The provided token is wrong. Please use the correct link</div>
</template>
